import type {AudienceMember} from 'src/types/audience-member';
import type {AudienceList} from 'src/types/audience-list';


export function getPhoneNumber({
  tags,
}: // @ts-expect-error - TS7030 - Not all code paths return a value.
AudienceMember): string | null | undefined {
  if (tags['phone number']) {
    return tags['phone number'];
  }
  for (const tagName in tags) {
    if (tagName.match(/(phone|cell|mobile)/)) {
      return tags[tagName];
    }
  }
}

export function getListIds(
  lists: Array<
    Partial<{
      filter: AudienceList;
    }>
  >,
): Array<string> {
  // @ts-expect-error - TS18048 - 'filter' is possibly 'undefined'.
  const listIds = lists.map(({filter}) => filter.id);
  return listIds;
}
